export default __webpack_public_path__ + "static/media/expl-nn_07_DE.03136f70.png";